import styled from 'styled-components';

export const Wrapper = styled.div`
  box-sizing: border-box;
  padding: 18px;
`;

export const Trigger = styled.button`
  box-sizing: border-box;
  gap: 12px;
  align-items: center;
  grid-auto-flow: column;
  display: inline-grid;
  
  line-height: 18px;
  font-size: 13px;
`;

export const Icon = styled.div`
  padding-top: 2px;
  display: grid;
`;

export const Title = styled.span`
  white-space: nowrap;
  display: block;
  margin-bottom: 20px;
  font-weight: 500;
`;

export const Content = styled.fieldset`
  min-width: 180px;
  gap: 14px;
  border: none;
  padding: 0;
  
  display: grid;
  text-align: left;
`;
